export default "__VITE_ASSET__CMlIKTbM__"